import { Box, Flex, Tag } from "@chakra-ui/react"
import { useBrandedTranslation } from "../../common/hooks/useBrandedTranslation"
import OverflowingText from "./OverflowingText"

type Props = {
  variant?: "dot" | "tag"
}

const PhasingOutIndicator = ({ variant = "dot" }: Props) => {
  const { t } = useBrandedTranslation()

  return variant === "dot" ? (
    <Flex gap="2" alignItems="center" justifyContent="flex-start" color="gray.900">
      <Box as="span" minW="2" minH="2" borderRadius="50%" bgColor="warning" />
      <OverflowingText text={t("indicator-passivated")} noOfLines={1} fontSize="xs" textAlign="left" />
    </Flex>
  ) : (
    <Tag variant="indicatorPhasingOut">{t("indicator-passivated")}</Tag>
  )
}

export default PhasingOutIndicator
